import React from 'react';

const IconAngleLeft: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.53481 12.0001L16.9856 19.4758C17.2752 19.7319 17.3022 20.1743 17.0461 20.4639C16.7899 20.7534 16.3476 20.7805 16.058 20.5244L7.01452 12.5244C6.69959 12.2458 6.69959 11.7544 7.01452 11.4758L16.058 3.47576C16.3476 3.21961 16.7899 3.24669 17.0461 3.53626C17.3022 3.82582 17.2752 4.2682 16.9856 4.52435L8.53481 12.0001Z"
      fill="currentColor"
    />
  </svg>
);

export default IconAngleLeft;
